/**
 * iOS 26 toolbar sampling only. The keyboard accessory bar does NOT snapshot
 * position:fixed nodes (this file included) — it composites a slice of in-flow
 * page content. Stretching this tint cannot paint that glass; see checkout
 * `blur-2xl` on the page behind the sheet.
 */
const KEYBOARD_GAP_MIN_PX = 150;
const ACCESSORY_OVERLAP_PX = 8;

function bottomTint(): HTMLElement | null {
  const el = document.querySelector('.safari-chrome-tint--bottom');
  return el instanceof HTMLElement ? el : null;
}

function reset(el: HTMLElement) {
  el.style.top = '';
  el.style.bottom = '';
  el.style.height = '';
  el.style.minHeight = '';
}

function sync() {
  const el = bottomTint();
  if (!el) return;

  const vv = window.visualViewport;
  const layoutH = window.innerHeight;
  const vvBottom = (vv?.offsetTop ?? 0) + (vv?.height ?? layoutH);
  const gap = layoutH - vvBottom;

  if (gap <= KEYBOARD_GAP_MIN_PX) {
    reset(el);
    return;
  }

  const top = Math.max(0, vvBottom - ACCESSORY_OVERLAP_PX);
  el.style.top = `${top}px`;
  el.style.bottom = 'auto';
  el.style.height = `${layoutH - top}px`;
  el.style.minHeight = `${layoutH - top}px`;
}

export function initSafariKeyboardTint() {
  if (typeof window === 'undefined') return;
  const vv = window.visualViewport;
  vv?.addEventListener('resize', sync);
  vv?.addEventListener('scroll', sync);
  window.addEventListener('resize', sync);
  sync();
}

initSafariKeyboardTint();
